export default __webpack_public_path__ + "static/media/gray-glass.bfe4c3b2.svg";